import { Task } from 'src/generated/api/krakenn-api/model/models';

export class DashboardMyTasksType {
  static className = 'MyTask';
  static gqlRootQueryName = 'mytask';
  static gqlColumns: string[] = [
    '_id',
    'jiraId',
    'name',
    'priority',
    'missionId',
    'collaboratorId',
    'sumTimeImputation',
    'globalPriority',
    'description',
    'lastRaf',
    'terminated',
    'targetDate',
    'targetPoints',
    'nbOfComments',
    `mission {
            _id,
            name,
            status,
            project {
                name
            }
        }
    collaboratorName`,
  ];

  static gqlNodeMapper = (node: any): Task => {
    node.id = node._id;
    delete node._id;
    delete node.__typename;
    return node as Task;
  };
}
